import { ReactNode } from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  titleModal: string;
  children: ReactNode;
  type?: string;
};

const Modal = ({ isOpen, onClose, titleModal, children, type }: ModalProps) => {
  const isType =
    titleModal === "Digital AI Concierge" &&
    type === "iCXeed" &&
    "iCXeed | Gen AI Chatbots";

  const advanceContactCentre =
    type === "Advanced Contact Centre Reporting & Analytics";

  const finalTitle = (() => {
    if (isType) return isType;
    if (advanceContactCentre) return type;
    if (type) return `${type} | ${titleModal}`;
    return titleModal;
  })();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-container-iris-blk custom-scrollbar"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          <motion.div
            className="modal-container-iris-main-blk"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            {/* Header */}
            <div className="header-modal">
              <h1 className="header-modal-title">{finalTitle}</h1>
              <button
                className="header-modal-close text-white"
                onClick={onClose}
              >
                <X />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="modal-content-iris-blk">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
